<template>
    <div class="single--select">
         <Select
            :options="prepareSelectOptions()"
            optionLabel="name"
            aria-placeholder="Bitte wählen ..."
            placeholder="Bitte wählen ..."
            :name="`${step.name}[${data.element_details.name}]`"
            v-model="field.value"
            optionValue="id"

         />
    </div>
</template>

<script setup>
import { ref, onMounted} from 'vue';

function handleSelect(val) {
    emit('update:modelValue', val);
    if (!!props.data.jump) {
        emit('update:slideForward');
    }
}

const props = defineProps({
    data:Object,
    field:Object,
    step:Object,
    modelValue: [String, Number, Array, Object]
});

const emit = defineEmits(['update:modelValue', 'update:slideForward']);

function prepareSelectOptions() {
    var options = [];
    
    props.data.valueOptions.forEach(op => {
        options.push({
            name: op.label,
            id: op.value
        })
    });
        
    return options;
}


</script>